namespace Matrix.Data {
    export interface GetCustomDateRequest extends Serenity.ServiceRequest {
        Kind?: string;
        InstanceCode?: string;
        SourceData?: CustomDateSourceData;
    }
}
